import environment from "@menu-environment";
import BaseService from "./base.service";
import { Country, MenuConfig, MenuCountry } from "../types";
import { ISampleDataProvider } from "./data/sample-data-provider.interface";

const useSampleData = !environment.production && environment.menu.useSampleData;

let sampleDataProvider: ISampleDataProvider | undefined = undefined;

class ConfigService extends BaseService {
    constructor() {
        super();
        this.setBaseUrl("umbraco/api/menu");
    }

    async getConfig(culture: string, siteName: string) {
        if (useSampleData) {
            sampleDataProvider = (await import("@menu-sample-data-provider")).default;
            return sampleDataProvider.getConfig(culture, siteName);
        }

        const path = `get?culture=${culture}&site=${siteName}`;
        const response = await this.createPromiseRequest(path).get<MenuConfig>();

        return response.data;
    }

    private convert(item: MenuCountry) {
        return {
            title: item.name,
            url: item.url,
            countryCode: item.code,
            flagImage: item.flagImage,
            languages: item.languages ?? [],
            opensInNewWindow: false,
            useCulture: true
        };
    }

    async getCountries(siteName: string) {
        if (useSampleData) {
            sampleDataProvider = (await import("@menu-sample-data-provider")).default;
            const data = sampleDataProvider.getCountries(siteName);
            return data.map(x => this.convert(x));
        }

        const path = `getmenucountries?site=${siteName}`;
        const response = await this.createPromiseRequest(path).get<MenuCountry[]>();

        const countries = response.data ?? [];

        const cultures: Country[] = [];

        for (let item of countries) {
            const country: Country = {
                title: item.name,
                url: item.url,
                countryCode: item.code,
                flagImage: item.flagImage,
                languages: item.languages ?? [],
                opensInNewWindow: false,
                useCulture: true
            };

            cultures.push(country);
        }

        return cultures;
    }
}

export default ConfigService;